import { createContext } from 'react';
import { CommentModel } from '../types/CommentModel';

// Per-game annotation state (comments, favourite moves, comment-panel target), fetched once and shared
// by the move list, action bar and comment panel.
export type AnnotationsContextType = {
  comments: CommentModel[];
  favorites: Set<string>; // favorited move PGNs
  loading: boolean;
  reload: () => Promise<void>;
  upsertComment: (comment: CommentModel) => void;
  removeComment: (id: number) => void;
  toggleFavorite: (movePgn: string) => Promise<void>;

  // Comment panel. Docked on desktop, tracking GameContext.currentMove; these drive the mobile bottom
  // sheet. panelClosing is true during the slide-down animation.
  panelOpen: boolean;
  panelClosing: boolean;
  openPanel: () => void;
  closePanel: () => void;

  // Comment box focus: a move's comment icon requests it and the composer consumes it on (re)mount. The
  // nonce bumps per request so a same-move re-request still fires. See CommentTreeView.
  composerFocusNonce: number;
  requestComposerFocus: (movePgn: string | null) => void;
  consumeComposerFocus: (movePgn: string | null) => boolean;
};

export default createContext<AnnotationsContextType>({
  comments: [],
  favorites: new Set<string>(),
  loading: false,
  reload: async () => {},
  upsertComment: () => {},
  removeComment: () => {},
  toggleFavorite: async () => {},
  panelOpen: false,
  panelClosing: false,
  openPanel: () => {},
  closePanel: () => {},
  composerFocusNonce: 0,
  requestComposerFocus: () => {},
  consumeComposerFocus: () => false,
});
